import React from 'react';
import { omit } from 'ramda';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import useApp from 'reducers/hooks/useApp';

import SteppedBuyerRegistrationForm from 'sharedComponents/SteppedBuyerRegistrationForm';

import useStyles from './useStyles';

const BuyerRegistration = props => {
  const classes = useStyles();
  const { signUp } = useApp();
  const { onFinish } = props;

  const handleSubmit = async values => {
    const attrs = omit('passwordConfirmation', values);
    await signUp({ ...attrs, userType: 'buyer' });
    onFinish();
  };

  return (
    <Box className={classes.container}>
      <SteppedBuyerRegistrationForm onSubmit={handleSubmit} />
    </Box>
  );
};

BuyerRegistration.propTypes = {
  onFinish: PropTypes.func.isRequired,
};

export default BuyerRegistration;



// WEBPACK FOOTER //
// ./src/components/BuyerLoanOfficerSearchSurvey/components/SurveyPage/components/BuyerRegistration/BuyerRegistration.js